import { Component, output } from '@angular/core';

@Component({
  selector: 'app-emulation-header',
  standalone: true,
  templateUrl: './emulation-header.component.html',
  styleUrl: './emulation-header.component.scss',
})
export class EmulationHeaderComponent {
  /** 「お客様利用内容」ボタン押下イベント */
  customerUsage = output<void>();

  /** 「ログアウト」ボタン押下イベント */
  logout = output<void>();

  onCustomerUsageClick(): void {
    this.customerUsage.emit();
  }

  onLogoutClick(): void {
    this.logout.emit();
  }
}
